import { render, staticRenderFns } from "./SchoolLog.vue?vue&type=template&id=0a5d0ac1&"
import script from "./SchoolLog.ts?vue&type=script&lang=ts&"
export * from "./SchoolLog.ts?vue&type=script&lang=ts&"
import style0 from "./SchoolLog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports